import type { MeetingDto } from "@/repositories/meetingRepo";
import React, { createContext, useContext } from "react";

export const MeetingDefaultsContext = createContext<Partial<MeetingDto> | null>(
  null
);

export const MeetingDefaults = ({
  defaults,
  children,
}: {
  defaults: Partial<MeetingDto>;
  children?: React.ReactNode;
}) => {
  const prevDefaults = useContext(MeetingDefaultsContext);
  const nextDefaults = { ...prevDefaults, ...defaults };

  return (
    <MeetingDefaultsContext.Provider value={nextDefaults}>
      {children}
    </MeetingDefaultsContext.Provider>
  );
};
